module.exports = __webpack_public_path__ + "media/images/puzzle/puzzle_40-800d36b0e3dcb13d69401c4863aa3107.png";